import { useLocation, useNavigate } from "react-router-dom";
import EditExerciseComponent from "./EditExerciseComponent"; 

const FutureSelfDetailView = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const video = location.state?.video; // Receiving the passed data
  const isEditing = location.state?.isEditing || false; // Check if editing mode is active

  if (!video) {
    return (
      <div className="container text-center mt-5">
        <h2>No Data Available</h2>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <div className="bg-white rounded shadow-sm">
        {isEditing ? (
          <EditExerciseComponent video={video} />
        ) : (
          <>
            <div className="cardHeader p-4">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-12 d-flex align-items-center gap-2">
                {/* Back Button */}
                <button
                  onClick={() => navigate(-1)}
                  style={{
                    background: "none",
                    border: "none",
                    padding: 0,
                    cursor: "pointer"
                  }}
                >
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M29.3333 15.9998C29.3333 8.64784 23.3519 2.6665 15.9999 2.6665C8.64792 2.6665 2.66659 8.64784 2.66659 15.9998C2.66659 23.3518 8.64792 29.3332 15.9999 29.3332C23.3519 29.3332 29.3333 23.3518 29.3333 15.9998ZM10.1146 15.9998L17.7239 8.3905L19.6093 10.2758L13.8853 15.9998L19.6093 21.7238L17.7239 23.6092L10.1146 15.9998Z"
                      fill="#27B99A"
                    />
                  </svg>
                </button>

                {/* Title */}
                <h2
                  className="mb-4 mb-lg-0 mb-md-0"
                  style={{ fontFamily: "Poppins", fontSize: "24px", fontWeight: 600 }}
                >
                  Future Self Detail View
                </h2>
              </div>

              {/* Edit Button */}
              <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="d-flex justify-content-end align-items-center gap-2">
                  <button
                    className="primaryBtn"
                    onClick={() => navigate("/future-self-questionnaire/edit", { state: { video, isEditing: true } })}
                  >
                    Edit
                  </button>
                </div>
              </div>
            </div>
          </div>

            
            <div className=" p-4 ">
              <p><strong>Exercise:</strong> {video.exercise}</p>
              <p><strong>Introduction Text:</strong> {video.intro_text}</p>
              <h4 className="mt-4">Questions:</h4>
              {video?.questions && video?.questions?.length > 0 ? (
                <ul>
                  {video.questions?.map((item, index) => (
                    <li key={index}  className="QuestionList">
                      <strong>Q{index + 1}:</strong> {item.question} {item.selectedTime && `( Time : ${item.selectedTime} sec)`}
                      <br />
                      <br />
                      {item.subQuestions && item.subQuestions.length > 0 && (
                        <ul>
                          {item.subQuestions.map((subQ, subIndex) => (
                            <li className="mb-3" key={subIndex}>
                               <strong>{subQ.subQuestion}</strong>
                              <strong> :</strong> {subQ.response}
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  ))}
                </ul>
              ) : (
                <p>No questions available.</p>
              )}
            </div>

           
          </>
        )}
      </div>
    </div>
  );
};

export default FutureSelfDetailView;
